// import { store } from 'redux/store';

import { getDataPoints } from '@pages/settings/helper';
import { cleanString } from '@utilities/attachments';

export const searchEquipmentData = ({ equipment, inputValue, store }) => {
  const { settings, picklists, cache } = store;
  const { picklistsMap, areaHierarchyTreeDataMap = {} } = picklists;
  const { sitesMap = {}, sites: cacheSites = [] } = cache;
  const { siteDisplayFields } = settings.settings;

  const siteHiddenDisplayFields = settings.hiddenDataPointsForAssets?.site || '';

  const {
    name,
    siteId,
    equipmentType: type,
    equipmentCategory: category,
    dataPoints,
    dataPointsForSearch = []
  } = equipment;

  const site = cacheSites[sitesMap[siteId]] || {};

  const categoryName = picklistsMap[category]?.value;
  const typeName = picklistsMap[type]?.value;
  const title = `${categoryName} - ${typeName}`;

  const siteTitle = site?.parent
    ? 'View all work at'
    : areaHierarchyTreeDataMap[site?.areaHierarchy || '']?.title || '';

  if (inputValue) {
    const equipmentDataPointsCombine = [...(dataPointsForSearch || []), ...(dataPoints || [])];

    const dataPointsObject = equipmentDataPointsCombine.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    const dataPointsForSite = siteDisplayFields
      ? equipment?.dataPointsForSite
        ? equipment?.dataPointsForSite
        : getDataPoints({ ...site, type: site.siteType }, siteDisplayFields, 'site', picklistsMap)
      : [];

    const siteDataPointsForSearch = siteHiddenDisplayFields
      ? equipment?.siteDataPointsForSearch
        ? equipment?.siteDataPointsForSearch
        : getDataPoints(
            { ...site, type: site?.siteType },
            siteHiddenDisplayFields,
            'site',
            picklistsMap
          )
      : [];

    const siteDataPointsCombine = [
      ...(siteDataPointsForSearch || []),
      ...(dataPointsForSite || [])
    ];

    const dataPointsObjectFOrSite = siteDataPointsCombine.reduce(
      (obj, item) => Object.assign(obj, { [item.key]: `${item.title} : ${item.value}` }),
      {}
    );

    const filterObject = {
      name,
      title,
      siteTitle,
      siteName: site?.name || '',
      ...dataPointsObject,
      ...dataPointsObjectFOrSite
    };

    const cleanInput = cleanString(inputValue);

    if (
      !Object.values(filterObject).some((value) => {
        return cleanString(String(value)).includes(cleanInput);
      })
    )
      return false;
  }

  return true;
};
